import { motion, useAnimationFrame } from "framer-motion";
import { useRef, useState } from "react";
import sevenSummitLogo from "../../assets/images/trusted-partners/seven-summit-treks-logo.png";
import karakoramLogo from "../../assets/images/trusted-partners/karakoram-club-logo.PNG";
import broadboyLogo from "../../assets/images/logo/light-logo-full.png";
import bgImage from "../../assets/images/hero-image-12-a.jpg";

export default function PartnershipSection() {
  const [x, setX] = useState(0);

  useAnimationFrame((_, delta) => {
    setX((prev) => {
      const next = prev - delta * 0.025;
      return next <= -2500 ? 0 : next;
    });
  });

  return (
    <section
      className="relative w-full py-32 text-white bg-cover bg-center bg-fixed overflow-hidden border-t border-neutral-800"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#091923]/75 z-0" />

      {/* Glow */}
      <div className="absolute inset-0 flex justify-center z-0 pointer-events-none">
        <div className="w-[60%] h-full bg-[#0e202b]/30 blur-3xl opacity-40" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6">

        {/* Title */}
        <div className="mb-16 max-w-xl">
          <p className="text-sm tracking-widest text-gray-400 mb-4">
            TRUSTED PARTNERSHIP
          </p>

          <h2 className="text-4xl lg:text-6xl font-semibold leading-tight mb-6 lg:whitespace-nowrap">
              IN COLLABORATION
            <span className="text-gray-400 ml-3">
              WITH
            </span>
          </h2>
        </div>

        {/* BELT */}
        <div className="relative overflow-hidden">

          {/* Edge fades */}
          <div className="absolute left-0 top-0 h-full w-24 bg-gradient-to-r from-[#202f3a] to-transparent z-10" />
          <div className="absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-[#202f3a] to-transparent z-10" />

          {/* Light sweep */}
          <motion.div
            className="absolute top-0 left-[-30%] h-full w-[30%] bg-gradient-to-r from-transparent via-white/10 to-transparent blur-2xl z-10"
            animate={{ x: ["0%", "300%"] }}
            transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
          />

          {/* Track */}
          <motion.div className="flex gap-24 w-max" style={{ x }}>
            {[...Array(10)].map((_, i) => (
              <div key={i} className="flex items-center gap-24">

                {/* Pair 1 */}
                <LogoPair
                  partnerLogo={sevenSummitLogo}
                  partnerName="Seven Summit"
                />

                {/* Dot separator */}
                <span className="text-gray-600 text-xl">•</span>

                {/* Pair 2 */}
                <LogoPair
                  partnerLogo={karakoramLogo}
                  partnerName="Karakoram Club"
                />

                {/* Dot */}
                <span className="text-gray-600 text-xl">•</span>

              </div>
            ))}
          </motion.div>

        </div>
      </div>
    </section>
  );
}

function LogoPair({ partnerLogo, partnerName }) {
  const ref = useRef(null);
  const [scale, setScale] = useState(1);

  useAnimationFrame(() => {
    if (!ref.current) return;

    const rect = ref.current.getBoundingClientRect();
    const center = window.innerWidth / 2;
    const itemCenter = rect.left + rect.width / 2;

    const distance = Math.abs(center - itemCenter);
    const newScale = 1 + Math.max(0, 0.22 - distance / 900);

    setScale(newScale);
  });

  return (
    <div ref={ref} className="flex items-center gap-10 whitespace-nowrap  mx-20 my-10">

      {/* BroadBoy */}
      <motion.img
        src={broadboyLogo}
        alt="BroadBoy"
        style={{ scale }}
        className="h-28 object-contain opacity-90"
      />

      {/* X */}
      <span className="text-3xl text-gray-300">×</span>

      {/* Partner */}
      <motion.img
        src={partnerLogo}
        alt={partnerName}
        style={{ scale }}
        className="h-28 object-contain opacity-90"
      />

    </div>
  );
}